export default __webpack_public_path__ + "static/media/demoImage.3617d49f.jpg";